import { HttpClient } from '@angular/common/http';
import { inject, Service } from '@angular/core';
import { Arrangement, ArrangementType } from '@thiememeulenhoff/types';
import { ArrangementsEndpointsService } from './arrangements.endpoints.service';

@Service()
export class ArrangementsService {
  readonly #http = inject(HttpClient);

  readonly #endpoints = inject(ArrangementsEndpointsService);

  public fetchArrangements(type: ArrangementType, methodSlug: string) {
    return this.#http.get<Array<Arrangement>>(this.#endpoints.arrangements(), {
      params: {
        'filter[arrangeable]': true,
        'filter[type]': type,
        'filter[methodSlug]': methodSlug,
        'filter[userDelete]': false,
      },
    });
  }
}
